<!--
	@name app-client-dashboard-property
	@description Client properties
	@date 2020/07/06
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<common-structure-section flex-height>
			<template #header>
				{{ (items && items.length) || '' }} {{ items && items.length === 1 ? 'Property' : 'Properties' }}
			</template>

			<template #body>
				<v-carousel
					v-if="items && items.length"
					v-model="carouselModel"
					:show-arrows="false"
					:cycle="cycle"
					interval="8000"
					height="100%"
					@change="carouselChangeHandler"
					@mouseover.native="cycle = false"
					@mouseleave.native="cycle = true"
				>
					<v-carousel-item v-for="(item, index) in items" :key="index" style="position: relative">
						<v-card
							class="mx-auto pa-3 pb-15 text-center d-flex flex-column property-background"
							light
							outlined
							style="height: 100%; background-color: rgba(255, 255, 255, 0.6)"
						>
							<v-list-item three-line>
								<v-list-item-content>
									<v-list-item-title class="title mb-0" style="text-shadow: 2px 2px white;">
										{{ propertyIdent(item.data.location) }}
									</v-list-item-title>
									<v-list-item-action class="justify-center mx-0 mb-0">
										<v-btn small color="secondary" :disabled="assetId === item.id" @click="loadProperty(item)">
											click to Open Property
										</v-btn>
									</v-list-item-action>
								</v-list-item-content>
							</v-list-item>
						</v-card>
					</v-carousel-item>
				</v-carousel>

				<div v-else-if="items && items.length === 0" class="text-left">
					<p class="text-body-1 mb-4">
						Let's add a Property for this Client.
					</p>
					<v-btn small color="secondary" @click="$emit('add-property')">
						Add Property
					</v-btn>
				</div>

				<v-skeleton-loader v-else type="image" />
			</template>
		</common-structure-section>
	</div>
</template>

<script>
	import CommonStructureSection from '@/component/common/structure/section';

	export default {
		name: 'app-client-dashboard-property',

		components: { CommonStructureSection },

		props: {
			clientId: { type: String, required: true },
			assetId: { type: String, required: false, default: null },
			items: { type: Array, default: null }
		},

		data() {
			return {
				carouselModel: 0,
				cycle: true
			};
		},

		mounted() {
		},

		methods: {
			loadProperty(property) {
				this.$emit('load-property', property);
			},

			propertyIdent(location) {
				const { address1, address2, townCity, postcode } = location;
				return [address1, address2, townCity, postcode].filter(Boolean).join(', ');
			},

			/**
			 * @name carouselChangeHandler
			 * @description Handler for carousel item changed event
			 */
			carouselChangeHandler() {
			},

			/**
			 * @name propertyDashboardPath
			 * @description Path for property dashboard
			 */
			propertyDashboardPath(item) {
				return `/client/${this.clientId}/property/${item.id}`;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.property-background {
		background: linear-gradient(150deg, color-mix(in lch, var(--v-primary-base) 20%, white 80%) 0%, color-mix(in lch, var(--v-secondary-base) 20%, white 80%) 60%);
	}
</style>